import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
// Import Swiper styles
// import "./styles.css";

import { FormattedMessage } from "react-intl";
import "./SlideNewVersion.scss";
// import Linkable from "component/LinkableComponent/linkable-component";
// import ChevronIcon from "svg-icons/chevron-icon";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import { END_POINTS } from "constants/APIConstant";
import useSWR from "swr";
import DataNotFound from "../DataNotFound/DataNotFound";
import MainButton from "../mainButton/MainButton";
import Divider from "component/divider/divider";
import { MONTH_CONSTANT } from "constants/MonthConstants";
import { QUARTER_YEAR_CONST } from "constants/PublicationConstants";
import { Col, Row } from "react-bootstrap";
import { API_BASE_URL } from "configs/AppConfig";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

function SlideNewVersion() {
  const currentLocale = useSelector(({ theme }) => theme.locale);

  const pubdetails = useSWR({
    url: END_POINTS.HOME_PUBLICATION_DETAILS,
  });

  const publications =
    pubdetails.error ||
    pubdetails.isLoading ||
    pubdetails.data === undefined ||
    pubdetails.data === null
      ? []
      : pubdetails.data.data;

  // const months = [
  //   "January",
  //   "February",
  //   "March",
  //   "April",
  //   "May",
  //   "June",
  //   "July",
  //   "August",
  //   "September",
  //   "October",
  //   "November",
  //   "December",
  // ];
  // const monthsArabic = [
  //   "يناير",
  //   "فبراير",
  //   "مارس",
  //   "أبريل",
  //   "مايو",
  //   "يونيو",
  //   "يوليو",
  //   "أغسطس",
  //   "سبتمبر",
  //   "أكتوبر",
  //   "نوفمبر",
  //   "ديسمبر",
  // ];
  // const quarters = [
  //   "First quarter",
  //   "Second quarter",
  //   "Third quarter",
  //   "Fourth quarter",
  // ];
  // const quartersArabic = [
  //   "الربع الأول",
  //   "الربع الثاني",
  //   "الربع الثالث",
  //   "الربع الرابع",
  // ];

  // const locale = useSelector(({ theme }) => theme.locale);

  const options = {
    loop: true,
    center: true,
    margin: 10,
    responsiveClass: true,
    autoplay: true,
    dots: false,
    smartSpeed: 500,
    nav: false,
    dir: "ltr",
    responsive: {
      0: {
        items: 1,
      },
      500: {
        items: 1,
      },
      600: {
        items: 2,
      },
      // 768: {
      //   items: 3,
      // },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  };
  const renderMonth = (month) => {
    const monthLabelId = MONTH_CONSTANT[month - 1].labelId;
    return <FormattedMessage id={monthLabelId} />;
  };
  const renderQuarter = (quarter) => {
    const getQuarter = QUARTER_YEAR_CONST.find((att) => att.value === quarter);
    const quarterLabelId = getQuarter.labelId;
    return <FormattedMessage id={quarterLabelId} />;
  };
  const renderPhotoAlbum = () => {
    const rendering = publications.map(
      ({ publicationCover, month, quarter, year, publication }, i) => (
        <div key={i} className="item">
          <Link to={`/publications/${publication.id}`}>
            <img
              loading="lazy"
              className="img"
              src={
                publicationCover
                  ? `${API_BASE_URL}/${publicationCover}`
                  : process.env.PUBLIC_URL + "/image/book.png"
              }
              alt="book"
            />
            <center className="testimonial-name">
              <Row>
                <Col
                  xs={12}
                  style={{ paddingBottom: "0px", marginBottom: "0px" }}
                >
                  <h6
                    title={LabelLangString({
                      id: "name",
                      currentLocale: currentLocale,
                      defaultValue: publication.name,
                      translations: publication.publicationTranslations,
                    })}
                    style={{ paddingBottom: "0px", marginBottom: "0px" }}
                  >
                    <LabelLang
                      id="name"
                      defaultValue={publication.name}
                      translations={publication.publicationTranslations}
                    />
                  </h6>
                </Col>
                <Col
                  xs={12}
                  style={{ paddingBottom: "0px", marginBottom: "0px" }}
                >
                  <h6 style={{ paddingBottom: "0px", marginBottom: "0px" }}>
                    {month
                      ? renderMonth(month)
                      : quarter
                      ? renderQuarter(quarter)
                      : ""}
                  </h6>
                </Col>
                <Col
                  xs={12}
                  style={{ paddingBottom: "0px", marginBottom: "0px" }}
                >
                  <h6 style={{ paddingBottom: "0px", marginBottom: "0px" }}>
                    {year ? year : ""}
                  </h6>
                </Col>
              </Row>
            </center>
          </Link>
        </div>
      )
    );

    return rendering;
  };

  return (
    <div className="new-verison">
      <Divider />
      <div className="section-title">
        <FormattedMessage id="selected-publications" />
      </div>
      <div className="row">
        <div className="SlideNewVersion home-slider">
          {Object.keys(renderPhotoAlbum()).length > 0 ? (
            <OwlCarousel
              id="publciation-details-testimonoals"
              className="owl-carousel owl-theme"
              {...options}
            >
              {renderPhotoAlbum()}
            </OwlCarousel>
          ) : (
            <DataNotFound />
          )}
        </div>
      </div>
      <div className="row-r pt-3 mt-5">
        <MainButton link={"publications"} text={"all-pubs"} />
      </div>
    </div>
  );
}

export default SlideNewVersion;
